import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/public/images/blog2.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/src/app/services/workflow-automation/workflow.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/Rocket.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/ServicesHero.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/VideoTextCard.jsx");
